import { Component , ChangeDetectorRef,ViewChild, Output, EventEmitter, Input, ElementRef, SimpleChanges} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';;
import * as FileSaver from 'file-saver';
import { Table } from 'primeng/table';
import { MenuItem, SelectItem, MessageService ,SortEvent} from "primeng/api";
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { ConsultaOrdenesTrabajoService, } from "../../servicios/ordenes-trabajo.service";

import { ConsultaOrdenesTrabajo, ConsultaOrdenesTrabajoInput,CatConceptos, EtapasOrdenes, Solicitudes, CancelaSolicitudInput, CatCalles, CatColonias, Medidores, Aguas, AuxJasper, ParametroJasper, RConceptosDirecciones } from "../../entidades/entidades";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { CatViaAtencionService } from "../../servicios/cat-via-atencion.service";
import { CatConceptosService} from "../../servicios/cat-conceptos.service";
import { CatCallesService } from 'app/servicios/cat-calles.service';
import { CatColoniasService } from 'app/servicios/cat-colonias.service';
import { CatDireccionesService } from 'app/servicios/cat-direcciones.service';
import { RegistraSolicitudesService } from 'app/servicios/registra-solicitudes.service';
import { ServiciosConsultasService } from 'app/servicios/servicios-consultas.service';
import { PersonasService } from 'app/servicios/personas.service';
import { MedidoresService } from 'app/servicios/medidores.service';
import { AguasService } from 'app/servicios/aguas.service';
import { RConceptosDireccionesService } from 'app/servicios/r-conceptos-direcciones.service';
import { AuthenticationService } from 'app/servicios';
import { data } from 'jquery'; 


@Component({
    selector: 'app-ordenes-trabajo',
    templateUrl: "./ordenes-trabajo.component.html",
    styleUrls: ["./ordenes-trabajo.component.css"],
    providers: [MessageService],
})
export class OrdenesTrabajoComponent { 
  public muestraMensaje = new MuestraMensaje();
    //DropDown

  //Entidad principal
  public consultaOrdenesTrabajo: ConsultaOrdenesTrabajo[] = [];
  public consultaOrdenesTrabajoCloned: ConsultaOrdenesTrabajo[] = [];
  public consultaOrdenesTrabajoFiltered: any[];

  //Elementos tabla
  public itemsMenu: MenuItem[];
  public columnasTabla: any[];
  public loading: boolean;
  catCalles: SelectItem[];
  catColonias: SelectItem[];
  Solicitud: Solicitudes;
  flagActualiza: boolean = false;
  //variables generales
  public estatus: SelectItem[];
  public reportesInspeccion: SelectItem[];
  public viaAtencion: SelectItem[];
  public conceptosOrdenes: SelectItem[];
  public ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
  public totalRecords: number;
  public progressBar = false;
  public formulario = true;
  public etapaNueva: EtapasOrdenes = new EtapasOrdenes();
  public EtapasOrdenes: EtapasOrdenes[] = [];
  public ordenSelet: ConsultaOrdenesTrabajo;
  public solicitudes = new Solicitudes();
  public auxJasper: AuxJasper;
  public display: boolean = false;
  public cancelaSolicitudInput = new CancelaSolicitudInput();
  public usuario: any;
  public personaClientesForm: FormGroup;
  numsRows: any[] = [];
  public catDireccionesAreas: SelectItem[];
  public getAreasGlobal: any[];
  public catDireccionesDepartamentos: SelectItem[];
  rConceptosDirecciones: RConceptosDirecciones[];
  public catDireccionesOficina: SelectItem[];
  @ViewChild('dtconsultaOrdenesTrabajo', { static: false }) table!: ElementRef;
  scrollPosition = 0;
  filtroForm: FormGroup;
  numsolicitud: number;
  muestraInspeccionReporte: boolean = false
  reportesInspeccionSelected: null;
  public editingRows: { [key: string]: boolean } = {};
  @ViewChild('dtconsultaOrdenesTrabajo') dtconsultaOrdenesTrabajo : Table;

  @Input()  inputOrdenesTrabajo: ConsultaOrdenesTrabajo[];
  @Input()  inputOrdenesTrabajoActualizado: number;
  @Input()  numsolicitudInput: number;
  @Input("esEstadoCuenta")   esEstadoCuenta: boolean = false;
  @Output() eventEmiteEtapa : EventEmitter<EtapasOrdenes[]> = new EventEmitter();
  @Output() eventEmiteInputId: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() outputOdenesTrabajo: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() eventCancelaSolicitudInput: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() eventImprimirOrden: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() eventImprimirOrdenMasivo: EventEmitter<number[]> = new EventEmitter();
  @Output() emitImprimirOrdenTrabajo: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() emitImprimirOrdenTrabajoMasivo: EventEmitter<number[]> = new EventEmitter();
  @Output() emitImprimirOrdenInspeccionMasivo: EventEmitter<number[]> = new EventEmitter();
  @Output() emitImprimirOrdenInspeccion: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() emitImprimirListadoOrdenTrabajo: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() emitImprimirListadoOrdenTrabajoMasivo: EventEmitter<number[]> = new EventEmitter();
  @Output() emitImprimirListadoOrdenTrabajoExcel: EventEmitter<ConsultaOrdenesTrabajo> = new EventEmitter();
  @Output() emitImprimirListadoOrdenTrabajoMasivoExcel: EventEmitter<number[]> = new EventEmitter();


  constructor(
    private catEstatusService : CatEstatusService,
    private catViaAtencionService: CatViaAtencionService,  
    private messageService: MessageService,
    private changeDetectorRef: ChangeDetectorRef,
    private registraSolicitudesService: RegistraSolicitudesService,
    private medidoresService: MedidoresService,
    private authenticationService: AuthenticationService,
    private catColoniasService: CatColoniasService,
    private rConceptosDireccionesService: RConceptosDireccionesService,
    private serviciosConsultasService: ServiciosConsultasService,
    private catDireccionesService: CatDireccionesService,
    private catConceptosService: CatConceptosService,
    private aguasService: AguasService,
    private personasService: PersonasService,
    private catCallesService: CatCallesService,
    private fb: FormBuilder, 
    private consultaOrdenesTrabajoService: ConsultaOrdenesTrabajoService,
  ) {
    this.filtroForm = this.fb.group({
      idEstatus: [null, [this.noEmptySpacesValidator]],
      orden: [null, [this.noEmptySpacesValidator]],
      fechaAlta: [null, [this.noEmptySpacesValidator]],
      fechaFin: [null, [this.noEmptySpacesValidator]],
      idConcepto: [null, [this.noEmptySpacesValidator]],
      solicitante: [null, [this.noEmptySpacesValidator]],
      nombre: [null, [this.noEmptySpacesValidator]],
      direccion: [null, [this.noEmptySpacesValidator]],
      colonia: [null, [this.noEmptySpacesValidator]],
      observaciones: [null, [this.noEmptySpacesValidator]],
      medidor: [null, [this.noEmptySpacesValidator]],
      telefonoOrdenes: [null, [this.noEmptySpacesValidator]],
      contrato: [null, [this.noEmptySpacesValidator]],
      idViaAtencion: [null, [this.noEmptySpacesValidator]],
      zonaOrdenes: [null, [this.noEmptySpacesValidator]],
      usuario: [null, [this.noEmptySpacesValidator]],
      idDireccion: [null, [this.noEmptySpacesValidator]],
      idDireccionDepartamento: [null, [this.noEmptySpacesValidator]],
      idDireccionOficina: [null, [this.noEmptySpacesValidator]],
      idColoniaIncidente: [null, [this.noEmptySpacesValidator]],
      idCalleIncidente: [null, [this.noEmptySpacesValidator]],
      idCalleIncidente1: [null, [this.noEmptySpacesValidator]],
      idCalleIncidente2: [null, [this.noEmptySpacesValidator]],   
      cveCuadrilla: [null, [this.noEmptySpacesValidator]],    
      // Agrega más campos según las columnas
    });
  }

  async ngOnInit(): Promise<void>  {
    try {
      this.progressBar = true; 

      await this.catConceptosOrdenes(); 
      await this.catEstatusAll();
      await this.catViaAtencionAll();
      if(this.esEstadoCuenta) await this.getOrdenesTrabajo();
      await this.getAllCatColonias();
      await this.getAllConceptosDireccion();
      await this.getAllAreas();
      //this.ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
      //await this.getAllConsultaOrdenesTrabajo(this.ordenesTrabajoInput);


      // ===============================================================
      //Opciones de la tabla
      // ===============================================================

      this.columnasTabla = [
        { field: "orden",         header: "Orden",           ordenar: false, style: "width: 60px; ",},
        { field: "contrato",      header: "Contrato",        ordenar: false, style: "width: 80px;",},
        { field: "idEstatus",     header: "Estatus",         ordenar: false, style: "width: 80px;",},
        { field: "fechaAlta",     header: "Fecha Alta",      ordenar: false, style: "width: 75px;",},
        { field: "idConcepto",    header: "Tipo Orden",      ordenar: false, style: "width: 150px;",},
        { field: "solicitante",   header: "Solicitante",     ordenar: false, style: "width: 150px;",},
        // { field: "nombre",        header: "Nombre",          ordenar: false, style: "width: 250px;",},
        { field: "direccion",     header: "Dirección",       ordenar: false, style: "width: 150px;",},
        //{ field: "colonia",       header: "Colonia",         ordenar: false, style: "width: 150px;",},
        { field: "observaciones", header: "Descripción",     ordenar: false, style: "width: 150px;",},
        { field: "medidor",       header: "Medidor",         ordenar: false, style: "width: 100px;",},
        { field: "telefonoOrdenes",      header: "Teléfono",        ordenar: false, style: "width: 100px;",},
        { field: "zonaOrdenes",   header: "Sector",            ordenar: false, style: "width: 80px;",},
        { field: "idColoniaIncidente",     header: "Colonia",       ordenar: false, style: "width: 150px;",},
        { field: "idCalleIncidente",       header: "Calle",         ordenar: false, style: "width: 150px;",},
        { field: "idCalleIncidente1",      header: "Entre Calle",   ordenar: false, style: "width: 150px;",},
        { field: "idCalleIncidente2",      header: "Entre Calle",   ordenar: false, style: "width: 150px;",},
        { field: "idDireccion",     header: "Área Asignada",       ordenar: false, style: "width: 150px;",},
        { field: "idDireccionDepartamento",     header: "Departamento",       ordenar: false, style: "width: 150px;",},
        { field: "idDireccionOficina",     header: "Oficina",       ordenar: false, style: "width: 150px;",},
        { field: "idViaAtencion", header: "Via de Atención", ordenar: false, style: "width: 150px;",}, 
        { field: "usuario",       header: "Usuario",         ordenar: false, style: "width: 150px;",},
        { field: "cveCuadrilla", header: "Clave Cuadrilla", ordenar: false, style: "width: 150px;",},
        
      ];

      if(!this.esEstadoCuenta)this.columnasTabla.unshift( { field: "operacion",     header: "",                ordenar: false, style: "width: 200px;"},);

      this.reportesInspeccion = [{label:"Orden de trabajo", value: 4}, {label:"Inspección Catastro", value: 1}, 
       {label:"Inspección Micromedición", value: 2}, {label:"Inspección Atención de usuarios", value: 3}, {label:"Listado de Ordenes de Trabajo", value: 5}, {label:"Listado de Ordenes de Trabajo Excel", value: 6}];
      this.reportesInspeccion.unshift({ label: 'SELECCIONA...', value: null });


      let filaNew = {
      numRow: -1, 
      baja: false,
      cambio: false,
      selected: false,
      id: -1,
      }
 
      this.dtconsultaOrdenesTrabajo.value.unshift(filaNew);

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally { 
      this.progressBar = false;
      console.log("paso por ngOnInit"); }
  };


  async  onDropdownChange(event: any, colField: string) { 
    const datoRetorno = await this.catCallesService.getSingleColonias(parseInt(event)).toPromise();
    this.catCalles = datoRetorno.map((datos) => {return { label: datos.descripcion, value: datos.id};});
    this.catCalles.unshift({label: 'SELECCIONA...',value: null});

    this.aplicaForm(event , colField);
   }

  // Método para capturar la posición del scroll
  saveScrollPosition() {
    const scrollable = this.table.nativeElement.querySelector('.ui-table-scrollable-body');
    if (scrollable) {
      this.scrollPosition = scrollable.scrollLeft;
    }
  }

  // Método para restaurar la posición del scroll
  restoreScrollPosition() {
    const scrollable = this.table.nativeElement.querySelector('.ui-table-scrollable-body');
    if (scrollable) {
      scrollable.scrollLeft = this.scrollPosition;
    }
  }

  // Llama estos métodos antes y después de aplicar filtros
  onFilter(event: any) {
    this.saveScrollPosition();
    setTimeout(() => {
      this.restoreScrollPosition();
    }, 0); // Aseguramos que se aplique después del render
  }

   async  onDropdownChangeidDireccion(event: any, colField: string) {
    this.catDireccionesDepartamentos = this.getAreasGlobal.filter((opcion) => opcion.idPadre === parseInt(event)) 
    .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})

    this.catDireccionesDepartamentos.unshift({ label: 'SELECCIONA...', value: null }); 

    this.aplicaForm(event , colField);

   }



   async  onDropdownChangeidDireccionDepartamento(event: any, colField: string) {
   
    this.catDireccionesOficina = this.getAreasGlobal.filter((opcion) => opcion.idPadre ===  parseInt(event)) 
    .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})

    this.catDireccionesOficina.unshift({ label: 'SELECCIONA...', value: null });

    this.aplicaForm(event , colField);
   }




   
   async  onDropdownChangeidDireccionOficina(event: any, colField: string) {
  
    this.aplicaForm(event , colField);
   }

   ngOnChanges(changes: SimpleChanges) { 
   if (changes['inputOrdenesTrabajoActualizado']) {
      this.Solicitud = changes['inputOrdenesTrabajoActualizado'].currentValue; 
      var index = this.consultaOrdenesTrabajo.findIndex(opcion => opcion.cambio); 
      if (index !== -1) {  
        this.consultaOrdenesTrabajo[index].cambio = false;
        this.consultaOrdenesTrabajo[index].idEstatus = this.Solicitud?.idEstatus; 
        let selectedOption: any = {};
        selectedOption = this.estatus.find(opcion => opcion.value === this.consultaOrdenesTrabajo[index].idEstatus);
        this.consultaOrdenesTrabajo[index].estatusDesc = selectedOption ? selectedOption.label: '';

        if(this.consultaOrdenesTrabajo[index].id == 0 ) {
          this.consultaOrdenesTrabajo[index].id = this.Solicitud?.id; 
          this.consultaOrdenesTrabajo[index].orden = this.Solicitud?.numSolicitud; 
        }
      }
      
      this.flagActualiza = true; 
    } 

  
  }

  

  //===============================================================
  //seleccion de fila 
  //===============================================================
  async onRowSelect(event: ConsultaOrdenesTrabajo, renglon) {
    //validamos que sea un registro nuevo
    event?.id == 0 ?  this.ordenSelet = event : null;
    this.eventEmiteInputId.emit(event);

    this.numsRows.push(renglon.data);

  }




  //===============================================================
  //Agrega renglon en el grid
  //===============================================================

  add() {
      try {
        // Buscar el índice del objeto con id = 1
        const index = this.consultaOrdenesTrabajo.findIndex(obj => obj.id === -1);

        // Si se encuentra, eliminarlo
        if (index !== -1) {
          this.consultaOrdenesTrabajo.splice(index, 1);
        }

        let registrosnew = this.consultaOrdenesTrabajo.filter( x => x.id == 0);

        if(registrosnew.length >= 1){
          throw new Error("Solo es posible crear una orden a la vez")
        }
 

        let tiempo = Date.now();
        let fechaActual = new Date(tiempo);
        let filaNew = {
        numRow: this.consultaOrdenesTrabajo.length, 
        baja: false,
        cambio: true,
        selected: false,
        id: 0,
        idEstatus: 13,  
        estatusDesc: 'PENDIENTE',
        orden: null,
        fechaAlta: fechaActual, 
        idConcepto: this.conceptosOrdenes?.[0]?.value,
        tipoOrden: this.conceptosOrdenes?.[0]?.label,
        idPersonaCliente: null,
        idPersonaPropietario: null,
        nombre: null,
        direccion: null,
        colonia: null,
        solicitante: null,
        observaciones: null,
        cveCuadrilla: null,
        medidor: null,
        telefonoOrdenes: null,
        contrato: null,
        idViaAtencion: null,
        viaAtencionDes: null,
        etapasOrdenes: null,
        zonaOrdenes: null,
        usuario: null,
        idCalleIncidente: null,
        calleIncidente: null,
        idColoniaIncidente: null,
        coloniaIncidente: null,
        idCalleIncidente1: null,
        calleIncidente1: null,
        idCalleIncidente2: null,
        calleIncidente2: null,
        imprimir: false,
        idDireccion: 0,
        direccionDescripcion: null, 
        idDireccionDepartamento: 0,
        direccionDepartamentoDescripcion: null, 
        idDireccionOficina: 0,
        direccionOficinaDescripcion: null, 
        }

         //Usamos una variable de paso, para la deteccion de cambios   
        let OrdenesTrabajoPaso: ConsultaOrdenesTrabajo[] = [];
        OrdenesTrabajoPaso = [...this.consultaOrdenesTrabajo];
        OrdenesTrabajoPaso.unshift(filaNew);
        this.consultaOrdenesTrabajo = [...OrdenesTrabajoPaso];
        
        //agregamos nueva fila a tabla
        this.dtconsultaOrdenesTrabajo.value.unshift(filaNew);
        this.dtconsultaOrdenesTrabajo.initRowEdit(filaNew);
        this.dtconsultaOrdenesTrabajo.sort;
        this.changeDetectorRef.detectChanges();
         
        

        //llamamos 'eventEmiteInputId()' pasamos la fila nueva el id = 0 indicara que se trata de una nueva orden
        this.eventEmiteInputId.emit(filaNew);
      } 
      catch (e) {
        this.muestraMensaje.error(e , "top", "center");
      }
      finally { console.log("add fila"); }
  };
    

  //===============================================================
  //Funciones de la tabla
  //===============================================================

  async onEditInit(event) {
    try {
      //await this.onRowSelect(event.data, event);
      
      this.eventEmiteInputId.emit(event.data);      
      if(event.data){
        if(event.data.cambio == true){
          return;
        }
          
        let consultaOrdenesTrabajoEdit = event.data;

        this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow] = { ...consultaOrdenesTrabajoEdit };
        consultaOrdenesTrabajoEdit.cambio = true;
        consultaOrdenesTrabajoEdit.baja = false;

      }

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
      console.log("Paso por onEditInit");
    }
    
  }

  async onEditComplete(event) {
    try {
      let consultaOrdenesTrabajoEdit = event.data;

      if(!this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow]){
        return
      }

      //Valida si hay cambios
      if (
        consultaOrdenesTrabajoEdit.idEstatus === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idEstatus &&
        consultaOrdenesTrabajoEdit.orden === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].orden &&
        consultaOrdenesTrabajoEdit.fechaAlta === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].fechaAlta && 
        consultaOrdenesTrabajoEdit.idConcepto === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idConcepto &&
        consultaOrdenesTrabajoEdit.nombre === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].nombre &&
        consultaOrdenesTrabajoEdit.direccion === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].direccion &&
        consultaOrdenesTrabajoEdit.colonia === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].colonia &&
        consultaOrdenesTrabajoEdit.solicitante === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].solicitante &&
        consultaOrdenesTrabajoEdit.observaciones === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].observaciones &&
        consultaOrdenesTrabajoEdit.cveCuadrilla === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].cveCuadrilla &&
        consultaOrdenesTrabajoEdit.medidor === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].medidor &&
        consultaOrdenesTrabajoEdit.telefonoOrdenes === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].telefonoOrdenes &&
        consultaOrdenesTrabajoEdit.contrato === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].contrato &&
        consultaOrdenesTrabajoEdit.idViaAtencion === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idViaAtencion &&
        consultaOrdenesTrabajoEdit.idDireccionDepartamento === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idDireccionDepartamento &&
        consultaOrdenesTrabajoEdit.contrato === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].contrato &&
        consultaOrdenesTrabajoEdit.idCalleIncidente === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idCalleIncidente &&
        consultaOrdenesTrabajoEdit.idCalleIncidente1 === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idCalleIncidente1 &&
        consultaOrdenesTrabajoEdit.entrec === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idCalleIncidente1 &&
        consultaOrdenesTrabajoEdit.idColoniaIncidente === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idColoniaIncidente &&
        consultaOrdenesTrabajoEdit.idDireccionOficina === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idDireccionOficina &&
        consultaOrdenesTrabajoEdit.idDireccion === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].idDireccion && 
        consultaOrdenesTrabajoEdit.zonaOrdenes === this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow].zonaOrdenes
      ) {
        let index = this.consultaOrdenesTrabajo.findIndex((obj) => obj.numRow === consultaOrdenesTrabajoEdit.numRow);
        this.consultaOrdenesTrabajo[index] = {...this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow]};
        return;
      }

      if(!this.flagActualiza) consultaOrdenesTrabajoEdit.cambio = true;
      consultaOrdenesTrabajoEdit.baja = false;
      
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
      this.flagActualiza = false;
    }
  }

  onEditCancel(event) {
    let consultaOrdenesTrabajoEdit = event.data;
    let index = this.consultaOrdenesTrabajo.findIndex(
      (obj) => obj.numRow === consultaOrdenesTrabajoEdit.numRow
    );
    this.consultaOrdenesTrabajo[index] = { ...this.consultaOrdenesTrabajoCloned[consultaOrdenesTrabajoEdit.numRow]};
  }

 
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  //===============================================================
  //Se replica metodo de ordenar de forma personalizada ya que al darle click en una de los encavezados
  //y despues actualizar la tabla este ya no mostraba de nuevo los datos en la tabla
  //===============================================================

  customSort(event: SortEvent) {

      event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  };

  //===============================================================
  //Interaccion con servicios
  //===============================================================

  async guardarGridConsultaOrdenesTrabajo() {
    try {
      //validamos y cargamos la cuenta
      //await this.getOrdenesTrabajo();
      this.outputOdenesTrabajo.emit(
        this.consultaOrdenesTrabajo.find(opcion => opcion.id === 0 && opcion.cambio)
      );
 
      

    } catch (e) {
      this.messageService.add({ key:'mensaje', severity: 'error', summary: 'Error', detail: e });
    } finally {
      console.log("Paso por guardarConsultaOrdenesTrabajo");
    }
  }

  async addOrdenesTrabajo(consultaOrdenesTrabajo) {
    
  }

  async getOrdenesTrabajo(){
    try{
      this.consultaOrdenesTrabajo = [];
      this.consultaOrdenesTrabajoCloned = [];

      if(this.inputOrdenesTrabajo?.length > 0){
        for (var i = 0, len = this.inputOrdenesTrabajo.length; i < len; ++i){
        this.consultaOrdenesTrabajo[this.inputOrdenesTrabajo[i].numRow] = {...this.inputOrdenesTrabajo[i]};
        this.consultaOrdenesTrabajoCloned[this.inputOrdenesTrabajo[i].numRow] = {...this.inputOrdenesTrabajo[i]};
        };
        this.EtapasOrdenes = []
        this.eventEmiteEtapa.emit(this.EtapasOrdenes)
      };
      
  } catch (e) {
    this.messageService.add({ key:'mensaje', severity: 'error', summary: 'Error', detail: e });
  } finally {
    console.log("Paso por getOrdenesTrabajo");
  }
  };

  
 

  async catEstatusAll() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.estatus = datoRetorno.filter((datos) => [13,14,4].includes(datos.id)).map((datos) => {return {label:datos.descripcion, value: datos.id}})
      this.estatus.unshift({ label: 'SELECCIONA...', value: null });
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    };
  };

  async catViaAtencionAll(){
    try {
      const datoRetorno = await this.catViaAtencionService.getAll().toPromise();
      this.viaAtencion = datoRetorno.map((datos) => {return { label: datos.viaAtencion, value: datos.idViaAtencion};});
      this.viaAtencion.unshift({label: 'SELECCIONA...',value: null})
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    };
  };


  async onEstatusSelec(renglon: any, event: any) {
    let selectedOption: any = {};
    selectedOption = this.estatus.find(opcion => opcion.value === event.value);
    renglon.estatusDesc = selectedOption ? selectedOption.label: '';
  };

  async onTipoOrdenSelec(renglon: any, event: any){
    let selectedOption: any = {};
    selectedOption = this.conceptosOrdenes.find(opcion => opcion.value === event.value);
    renglon.tipoOrden = selectedOption ? selectedOption.label: '';
    renglon.idConcepto = selectedOption.value;

    //se llenan los drop de area, departamento, oficina 

    var auxPadre              = this.rConceptosDirecciones.find(opcion => opcion.idConcepto === event.value);
    var auxPadreOficina       = this.getAreasGlobal.find(opcion => opcion.id === auxPadre?.idDireccion);
    var auxPadreDepartamento  = this.getAreasGlobal.find(opcion => opcion.id === auxPadreOficina?.idPadre);
    var auxPadreArea          = this.getAreasGlobal.find(opcion => opcion.id === auxPadreDepartamento?.idPadre);
   
    if(auxPadre == undefined) return;
    //2 niveles (area y depa)
    if(auxPadreArea == undefined)
    {
      let event: any = {};
      event.value =  auxPadreDepartamento.id;
      await this.onDireccionSelec(renglon, event);

      let eventDepa: any = {};
      eventDepa.value =  auxPadreOficina.id;
      await this.onDireccioDepartamentonSelec(renglon, eventDepa);

    }
    //area, depa, oficina
    // 3 niveles
    else 
    {

      let event: any = {};
      event.value =  auxPadreArea.id;
      await this.onDireccionSelec(renglon, event);

      let eventDepa: any = {};
      eventDepa.value =  auxPadreDepartamento.id;
      await this.onDireccioDepartamentonSelec(renglon, eventDepa);

      let eventOficina: any = {};
      eventOficina.value =  auxPadreOficina.id;
      await this.onDireccionOficinaSelec(renglon, eventOficina);


    }
  };

  async onViAtencionSelec(renglon: any, event: any){
    let selectedOption: any = {};
    selectedOption = this.viaAtencion.find(opcion => opcion.value === event.value);
    renglon.viaAtencionDes = selectedOption ? selectedOption.label: '';
  };


  
  async catConceptosOrdenes(){
    try {
      const datoRetorno = await this.catConceptosService.getAll().toPromise();
      this.conceptosOrdenes = datoRetorno.filter((datos) => [5].includes(datos.idGrupoConcepto)).map((datos) => {return {label:datos.descripcion, value: datos.id}})
      
      //this.conceptosOrdenes.unshift({label: 'SELECCIONA...',value: null})
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }
  };

  cancelarSolicitud(event: ConsultaOrdenesTrabajo) {
    this.eventCancelaSolicitudInput.emit(event)
  }

  emitImprimeOrden(event: ConsultaOrdenesTrabajo){
    this.eventImprimirOrden.emit(event)
  };

  emitImprimeOrdenTrabajo(event: ConsultaOrdenesTrabajo){
    this.emitImprimirOrdenTrabajo.emit(event)
  };


  emitImprimeOrdenInsepccion(event: ConsultaOrdenesTrabajo){
    this.numsRows = [];
    this.numsRows.push(event);
    this.muestraInspeccionReporte = true;
  };

  emitImprimeOrdenInspeccion(event: ConsultaOrdenesTrabajo){
    this.emitImprimirOrdenInspeccion.emit(event)
  };
  
  emitImprimeListadoOrdenTrabajoMasivo(event: ConsultaOrdenesTrabajo){
    this.emitImprimirListadoOrdenTrabajo.emit(event)
  };

  emitImprimeListadoOrdenTrabajoMasivoExcel(event: ConsultaOrdenesTrabajo){
    this.emitImprimirListadoOrdenTrabajoExcel.emit(event)
  };

  async getAllAreas() {
    try {
      const datoRetorno = await this.catDireccionesService.getAll().toPromise();
      this.getAreasGlobal = datoRetorno;
      this.catDireccionesAreas = datoRetorno.filter((datos) => [null].includes(datos.idPadre))
      .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})

      this.catDireccionesAreas.unshift({ label: 'SELECCIONA...', value: null });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }


  async getAllCatColonias() {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonias = datoRetorno.map((datos) => {return { label: datos.descripcion, value: datos.id};});
      this.catColonias.unshift({label: 'SELECCIONA...',value: null});

    
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }

  async getAllConceptosDireccion() {
    try {
      const datoRetorno = await this.rConceptosDireccionesService.getAll().toPromise();
      this.rConceptosDirecciones = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getAllConceptosDireccion');
    }
  }

  async onDireccionSelec(renglon: any, event: any){
    try {
       let selectedOption: any = {};
       selectedOption = this.catDireccionesAreas.find(opcion => opcion.value === event.value);
       renglon.direccionDescripcion = selectedOption ? selectedOption.label: '';
       renglon.idDireccion = selectedOption.value;

       this.catDireccionesDepartamentos = this.getAreasGlobal.filter((opcion) => opcion.idPadre === selectedOption.value) 
       .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})

       this.catDireccionesDepartamentos.unshift({ label: 'SELECCIONA...', value: null });
 

     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log('Paso por onDireccionSelec');
     }
   }

   async onDireccionOficinaSelec(renglon: any, event: any){
    try {
      let selectedOption: any = {};
      selectedOption = this.catDireccionesOficina.find(opcion => opcion.value === event.value);
      renglon.direccionOficinaDescripcion = selectedOption ? selectedOption.label: '';
      renglon.idDireccionOficina = selectedOption.value;

     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log('Paso por onDireccionOficinaSelec');
     }
   }


   async onDireccioDepartamentonSelec(renglon: any, event: any){
    try {
       let selectedOption: any = {};
       selectedOption = this.catDireccionesDepartamentos.find(opcion => opcion.value === event.value);
       renglon.direccionDepartamentoDescripcion = selectedOption ? selectedOption.label: '';
       renglon.idDireccionDepartamento = selectedOption.value;

       this.catDireccionesOficina = this.getAreasGlobal.filter((opcion) => opcion.idPadre === selectedOption.value) 
       .map((datos)=> {return {label:datos.descripcion, value:datos.id  , title: datos.idPadre?.toString()}})

       this.catDireccionesOficina.unshift({ label: 'SELECCIONA...', value: null });
 

     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log('Paso por onDireccioDepartamentonSelec');
     }
   }

  async onColoniaSelec(renglon: any, event: any){
   try {
      let selectedOption: any = {};
      selectedOption = this.catColonias.find(opcion => opcion.value === event.value);
      renglon.coloniaIncidente = selectedOption ? selectedOption.label: '';
      

      const datoRetorno = await this.catCallesService.getSingleColonias(event.value).toPromise();
      this.catCalles = datoRetorno.map((datos) => {return { label: datos.descripcion, value: datos.id};});
      this.catCalles.unshift({label: 'SELECCIONA...',value: null})
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }


  
  async onCalleIncidenteSelec(renglon: any, event: any, opcion: number){
    try {
       let selectedOption: any = {};
       selectedOption = this.catCalles.find(opcion => opcion.value === event.value);
       if(opcion == 1) 
       {
        renglon.calleIncidente = selectedOption ? selectedOption.label: '';
       }
       else if (opcion == 2) 
       {
        renglon.calleIncidente1 = selectedOption ? selectedOption.label: '';
       }
       else if (opcion == 3)
       {
        renglon.calleIncidente2 = selectedOption ? selectedOption.label: '';
       }


     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log('Paso por getCatColonias');
     }
   }


  async onZonaOrdenesSelec(renglon: any, event: any){
    try {
      /* let selectedOption: any = {};
       selectedOption = this.catColonias.find(opcion => opcion.value === event.value);
       renglon.coloniaIncidente = selectedOption ? selectedOption.label: '';
       
 
       const datoRetorno = await this.catCallesService.getSingleColonias(event.value).toPromise();
       this.catCalles = datoRetorno.map((datos) => {return { label: datos.descripcion, value: datos.id};});
       this.catCalles.unshift({label: 'SELECCIONA...',value: null})*/
     } catch (e) {
       if (e.response) throw { message: e.response.data };
       else throw e;
     } finally {
       console.log('Paso por onZonaOrdenesSelec');
     }
   }

  

  onRowUnselect(event) {
    var index = this.numsRows.findIndex((obj) => obj.id === event.data.id);
    if (index !== -1) {
        this.numsRows.splice(index, 1);
    }  
  }

  onSelectAll(seleccion) {
    this.numsRows = seleccion;
  }

  async consultaAgua(contrato, renglon ){
    try 
    {   
      this.progressBar = true;

      const datoRetorno = await this.aguasService.getCuenta(contrato).toPromise();
      if(datoRetorno == null) 
        {
          this.muestraMensaje.error('No existe la cuenta', 'top', 'center');
          return;
        }
     
      renglon.direccion = datoRetorno.domicilio;
      ///////////////////////////////////////////////////////////////////////////////
      renglon.idColoniaIncidente = datoRetorno.idColonia;
      let idColoniaSelect: any = {};
      idColoniaSelect.value  = datoRetorno.idColonia; 
      let selectedOption: any = {};
      selectedOption = this.catColonias.find(opcion => opcion.value === datoRetorno.idColonia); 
       renglon.colonia = selectedOption.label; 
      await this.onColoniaSelec(renglon, idColoniaSelect);
      ///////////////////////////////////////////////////////////////////////////////
      renglon.idCalleIncidente = datoRetorno.idCalle;  
      selectedOption = {};
      selectedOption = this.catCalles.find(opcion => opcion.value === datoRetorno.idCalle); 
      renglon.calleIncidente = selectedOption ? selectedOption.label: '';
      ///////////////////////////////////////////////////////////////////////////////
      renglon.idCalleIncidente1 = datoRetorno.idCalleColinda1;  
      selectedOption = {};
      selectedOption = this.catCalles.find(opcion => opcion.value === datoRetorno.idCalleColinda1); 
      renglon.calleIncidente1 = selectedOption ? selectedOption.label: '';
      ///////////////////////////////////////////////////////////////////////////////
      renglon.idCalleIncidente2 = datoRetorno.idCalleColinda2;  
      selectedOption = {};
      selectedOption = this.catCalles.find(opcion => opcion.value === datoRetorno.idCalleColinda2); 
      renglon.calleIncidente2 = selectedOption ? selectedOption.label: '';
      ///////////////////////////////////////////////////////////////////////////////

      renglon.idZona    = datoRetorno.idAguaZona;
      renglon.zonaOrdenes    = datoRetorno.cveSec;


      await this.consultaPersona(datoRetorno.id, renglon)
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
      console.log(e)
    } finally {
      console.log('Paso por consultaAgua');
      this.progressBar = false;
    }
  }


  async consultaPersona(contrato, renglon){
    try 
    {    
      this.progressBar = true;
      const datoRetorno = await this.personasService.getPropietario(contrato).toPromise();

      renglon.solicitante = (datoRetorno.nombre ?? " ") + " " + (datoRetorno.primerApellido ?? " ") + " " + (datoRetorno.segundoApellido ?? " ") + " " + (datoRetorno.razonSocial  ?? " ");
      renglon.telefonoOrdenes = datoRetorno.telefono;

      await this.consultaMedidor(contrato, renglon)

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      console.log('Paso por consultaPersona');
      this.progressBar = false;
    }
  }

  async consultaMedidor(contrato, renglon){
    try 
    {    
      this.progressBar = true;
      let medidoresB = new Medidores();
      medidoresB.idAgua = contrato;
      medidoresB.idEstatus = 1;
      const datoRetorno = await this.medidoresService.getBusquedas(medidoresB).toPromise();
      for (let index = 0; index < Object.keys(datoRetorno).length; index++) {
        if(datoRetorno[index].idEstatus == 1 ) {
          renglon.medidor = datoRetorno[index].serie;
          return;
        }
        
      }

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      console.log('Paso por consultaMedidor');
      this.progressBar = false;
    }
  }

  async imprimeMasivo(opcion: number) {
    try 
    { 
      if (Object.keys(this.numsRows).length == 0)
      {
        this.muestraMensaje.error("Seleccione una solicitud para imprimir.", "top", "center");
        return;
      }

      var idJson = this.numsRows.map(w => w.id)
      if(opcion == 1 )
      {
        this.eventImprimirOrdenMasivo.emit(idJson);
      }
      else if(opcion == 2)
      {
        this.emitImprimirOrdenTrabajoMasivo.emit(idJson); 
      }
      else if(opcion == 3)
      {
        this.muestraInspeccionReporte = true;
      }
      else if(opcion == 5)
        {
          this.emitImprimirListadoOrdenTrabajoMasivo.emit(idJson); 
        }
        else if(opcion == 6){
          this.emitImprimirListadoOrdenTrabajoMasivoExcel.emit(idJson);
        }


    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por imprimeMasivo');
    }
  }

  async imprimeInspeccion(opcion: number) {
    try 
    { 

      if (this.reportesInspeccionSelected == null)
      {
        this.muestraMensaje.error("Seleccione un tipo de reporte para imprimir.", "top", "center");
        return;
      }

      var idJson = this.numsRows.map(w => w.id)
      this.emitImprimirOrdenInspeccionMasivo.emit(idJson); 

     

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por imprimeInspeccion');
    }
  }



  showDialog() {
    this.display = true;
  }

 
 
  async consultarOrdenes() {
    try
    {
      this.progressBar = true;
      if (!this.isValidForm())  throw new Error("Ingrese algun valor para buscar.")    

    // Reemplazar "" con null para todos los campos
    const formValues = { ...this.filtroForm.value };

    Object.keys(formValues).forEach((key) => {
      if (formValues[key] === '') {
        formValues[key] = null;
      }
    });

    // Actualizar el formulario (opcional, si necesitas que el formulario refleje los valores ajustados)
    this.filtroForm.patchValue(formValues);

      // Aquí puedes ejecutar la lógica de filtrado

      this.consultaOrdenesTrabajo = [];

      let OrdenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
      OrdenesTrabajoInput.numOrdenT = this.filtroForm.value?.orden;
      OrdenesTrabajoInput.cuentaAgua = this.filtroForm.value?.contrato;
      OrdenesTrabajoInput.idEstatus = this.filtroForm.value?.idEstatus;
      OrdenesTrabajoInput.fechaAlta = this.filtroForm.value?.fechaAlta;
      OrdenesTrabajoInput.fechaFin = this.filtroForm.value?.fechaFin;
      const idConcepto = this.filtroForm.value?.idConcepto;
      if (idConcepto && Array.isArray(idConcepto) && idConcepto.length > 0)  OrdenesTrabajoInput.idConcepto = this.filtroForm.value?.idConcepto.join(',');
      OrdenesTrabajoInput.solicitante = this.filtroForm.value?.solicitante;
      OrdenesTrabajoInput.direccion = this.filtroForm.value?.direccion;
      OrdenesTrabajoInput.observaciones = this.filtroForm.value?.observacion;
      OrdenesTrabajoInput.cveCuadrilla = this.filtroForm.value?.cveCuadrilla;
      OrdenesTrabajoInput.medidor = this.filtroForm.value?.medidor;
      OrdenesTrabajoInput.telefonoOrdenes = this.filtroForm.value?.telefonoOrdenes;
      OrdenesTrabajoInput.zonaOrdenes = this.filtroForm.value?.zonaOrdenes;
      OrdenesTrabajoInput.idColonia = this.filtroForm.value?.idColoniaIncidente;
      OrdenesTrabajoInput.idCalle = this.filtroForm.value?.idCalleIncidente;
      OrdenesTrabajoInput.idCalle1 = this.filtroForm.value?.idCalleIncidente1;
      OrdenesTrabajoInput.idCalle2 = this.filtroForm.value?.idCalleIncidente2;
      OrdenesTrabajoInput.idDireccion = this.filtroForm.value?.idDireccion;
      OrdenesTrabajoInput.idDepartamento = this.filtroForm.value?.idDireccionDepartamento;
      OrdenesTrabajoInput.idOficina = this.filtroForm.value?.idDireccionOficina;
      OrdenesTrabajoInput.idAtencion = this.filtroForm.value?.idViaAtencion;
      OrdenesTrabajoInput.usuario = this.filtroForm.value?.usuario;
      
      const datoRetorno = await this.consultaOrdenesTrabajoService.getAll(OrdenesTrabajoInput).toPromise();

      if(Object.keys(datoRetorno).length == 0)  
        {
          let filaNew = {
            numRow: -1, 
            baja: false,
            cambio: false,
            selected: false,
            id: -1,
            };
            
          this.dtconsultaOrdenesTrabajo.value.unshift(filaNew);
          throw new Error("No se encontraron resultados.")   
        }

        // Buscar el índice del objeto con id = 1
        const index = this.consultaOrdenesTrabajo.findIndex(obj => obj.id === -1);

        // Si se encuentra, eliminarlo
        if (index !== -1) {
          this.consultaOrdenesTrabajo.splice(index, 1);
        }

      for (var i = 0, len = datoRetorno?.length; i < len; ++i){
        let element:ConsultaOrdenesTrabajo = JSON.parse(datoRetorno[i].renglon)
        element.fechaAlta = new Date(element.fechaAlta);
        this.consultaOrdenesTrabajo.push(element[0])
      }

      for (var i = 0, len = this.consultaOrdenesTrabajo?.length; i < len; ++i){
        this.consultaOrdenesTrabajo[i].numRow = i;
        this.consultaOrdenesTrabajo[i].cambio = false;
        this.consultaOrdenesTrabajo[i].baja = false; 
        this.consultaOrdenesTrabajoCloned[this.consultaOrdenesTrabajo[i].numRow] = {...this.consultaOrdenesTrabajo[i]};
      }
	  this.EtapasOrdenes = [];
	  this.eventEmiteEtapa.emit(this.EtapasOrdenes);
   // Establecer el total de registros
   this.totalRecords = this.consultaOrdenesTrabajo.length; // Esto asegura que el paginador funcione correctamente

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally {
      console.log('Paso por consultarOrdenes');
      this.progressBar = false;
    }
  }

    // Validador personalizado para evitar valores vacíos o solo espacios
    noEmptySpacesValidator(control: AbstractControl): ValidationErrors | null {
      const value = control.value;
      if (value != null && typeof value === 'string' && value.trim() === '') {
        return { emptySpaces: 'El valor no puede contener solo espacios' };
      }
      return null;
    }

    isValidForm(): boolean {
      const formValues = this.filtroForm.value;
    
      // Verifica si al menos un campo tiene un valor válido
      return Object.values(formValues).some(value => {
        if (typeof value === 'string') {
          return value.trim() !== ''; // Es válido si no es solo espacios
        }
        return value !== null && value !== undefined; // Es válido si no es null o undefined
      });
    }


    aplicaForm(valor: string, campo: string) {

      const campoMap = {  
        'idEstatus': 'idEstatus',
        'orden': 'orden',
        'fechaAlta': 'fechaAlta',
        'fechaFin': 'fechaFin', 
        'idConcepto': 'idConcepto',
        'solicitante': 'solicitante',
        'nombre': 'nombre',
        'direccion': 'direccion',
        'observaciones': 'observaciones',
        'cveCuadrilla': 'cveCuadrilla',
        'medidor': 'medidor',
        'telefonoOrdenes': 'telefonoOrdenes',
        'contrato': 'contrato',
        'idViaAtencion': 'idViaAtencion',
        'zonaOrdenes': 'zonaOrdenes',
        'usuario': 'usuario',
        'idDireccion': 'idDireccion',
        'idDireccionDepartamento': 'idDireccionDepartamento',
        'idDireccionOficina': 'idDireccionOficina',
        'idColoniaIncidente': 'idColoniaIncidente',
        'idCalleIncidente': 'idCalleIncidente',
        'idCalleIncidente1': 'idCalleIncidente1',
        'idCalleIncidente2': 'idCalleIncidente2' 
      };
    
      if (campoMap[campo]) {
        this.filtroForm.patchValue({
          [campoMap[campo]]: valor
        });
      }
 
    }
 

}